import api from "../../infra/api";

class ServEquipamentos {
    async listar(codigoResponsavel, filtro) {
        const response = await api({
            method: "GET",
            url: filtro.trim() === "" ?
            `api/v1/Equipamentos/${codigoResponsavel}/ListarEquipsParaSolic?page=1&start=0&limit=9999&fields=["Id","Descricao","Situacao","Tipo","Fabricante","Modelo","NumeroFases","PotenciaKw","DataValidadeCertificacao","Ativo","DataCadastro","CodigoResponsavelTecnico","DataPrazoAnalise","DataHomologacaoCadastro","DataEnvioHomologacao","CadastradoPorAnalista","CodigoTensaoFornecimento","RespTecnico.Id","RespTecnico.Situacao","RespTecnico.Email","RespTecnico.Nome","RespTecnico.Empresa","RespTecnico.DddFone","RespTecnico.Celular","RespTecnico.CPF","RespTecnico.Crea","RespTecnico.DataValidadeCrea","RespTecnico.Ativo","RespTecnico.DataCadastro","RespTecnico.DataAprovacaoCadastro","RespTecnico.DataPrazoAnalise","RespTecnico.DataEnvioSolicitacao","TensaoFornecimento","Fabricantes"]` 
            : `api/v1/Equipamentos/${codigoResponsavel}/ListarEquipsParaSolic?page=1&start=0&limit=999&fields=["Id","Descricao","Situacao","Tipo","Fabricante","Modelo","NumeroFases","PotenciaKw","DataValidadeCertificacao","Ativo","DataCadastro","CodigoResponsavelTecnico","DataPrazoAnalise","DataHomologacaoCadastro","DataEnvioHomologacao","CadastradoPorAnalista","CodigoTensaoFornecimento","RespTecnico.Id","RespTecnico.Situacao","RespTecnico.Email","RespTecnico.Nome","RespTecnico.Empresa","RespTecnico.DddFone","RespTecnico.Celular","RespTecnico.CPF","RespTecnico.Crea","RespTecnico.DataValidadeCrea","RespTecnico.Ativo","RespTecnico.DataCadastro","RespTecnico.DataAprovacaoCadastro","RespTecnico.DataPrazoAnalise","RespTecnico.DataEnvioSolicitacao","TensaoFornecimento","Fabricantes"]&filter=[{"property":"Modelo","operator":"containsall","value":"${filtro}","and":false},{"property":"Fabricante","operator":"containsall","value":"${filtro}","and":false},{"property":"Descricao","operator":"containsall","value":"${filtro}","and":false},{"property":"PotenciaKw","operator":"equal","value":"${filtro}","and":false}]` 
        });

        return response.data;
    };

    async listarCfeTipoOuSituacao(codigoResponsavel, filtro, tipoEquipamento, situacoes, codigo) {
        let filter = this.retornarFilterDeAcordoComFiltros(filtro, tipoEquipamento, situacoes, codigo);

        const response = await api({
            method: "GET",
            url: filter.trim() === "" ?
                `api/v1/Equipamentos/${codigoResponsavel}/ListarEquipsParaSolic?page=1&start=0&limit=9999&fields=["Id","Descricao","Situacao","Tipo","Fabricante","Modelo","NumeroFases","PotenciaKw","DataValidadeCertificacao","Ativo","DataCadastro","CodigoResponsavelTecnico","DataPrazoAnalise","DataHomologacaoCadastro","DataEnvioHomologacao","CodigoTensaoFornecimento","RespTecnico.Id","RespTecnico.Situacao","RespTecnico.Email","RespTecnico.Nome","RespTecnico.Empresa","RespTecnico.DddFone","RespTecnico.Celular","RespTecnico.CPF","RespTecnico.Crea","RespTecnico.DataValidadeCrea","RespTecnico.Ativo","RespTecnico.DataCadastro","RespTecnico.DataAprovacaoCadastro","RespTecnico.DataPrazoAnalise","RespTecnico.DataEnvioSolicitacao","TensaoFornecimento","Fabricantes"]` :
                `api/v1/Equipamentos/${codigoResponsavel}/ListarEquipsParaSolic?page=1&start=0&limit=9999&fields=["Id","Descricao","Situacao","Tipo","Fabricante","Modelo","NumeroFases","PotenciaKw","DataValidadeCertificacao","Ativo","DataCadastro","CodigoResponsavelTecnico","DataPrazoAnalise","DataHomologacaoCadastro","DataEnvioHomologacao","CodigoTensaoFornecimento","RespTecnico.Id","RespTecnico.Situacao","RespTecnico.Email","RespTecnico.Nome","RespTecnico.Empresa","RespTecnico.DddFone","RespTecnico.Celular","RespTecnico.CPF","RespTecnico.Crea","RespTecnico.DataValidadeCrea","RespTecnico.Ativo","RespTecnico.DataCadastro","RespTecnico.DataAprovacaoCadastro","RespTecnico.DataPrazoAnalise","RespTecnico.DataEnvioSolicitacao","TensaoFornecimento","Fabricantes"]&filter=${filter}` 
        });

        return response.data;
    };

    retornarFilterDeAcordoComFiltros(filtro, tipoEquipamento, situacoes, codigo) {
        let temPesquisaGeral = filtro.trim() !== "";

        if(temPesquisaGeral) {
            let filtroTipoSituacao = this.handleFiltrosTipoEquipamentoESituacao(tipoEquipamento, situacoes, codigo);
            let filtroFinal = "," + filtroTipoSituacao.slice(1);
            
            return `[{"property":"Descricao","operator":"containsall","value":"${filtro}","and":false},{"property":"Modelo","operator":"containsall","value":"${filtro}","and":false},{"property":"Fabricante","operator":"containsall","value":"${filtro}","and":false}` + filtroFinal;
        } else {
            return this.handleFiltrosTipoEquipamentoESituacao(tipoEquipamento, situacoes, codigo);
        }
    }

    handleFiltrosTipoEquipamentoESituacao(tipoEquipamento, situacoes, codigo) {
        let filtros = [];
        
        // Adiciona o filtro de código, se informado
        if (codigo) {
            filtros.push({"property":"Id","operator":"equal","value":codigo,"and":true,"not":false});
        }
    
        // Verifica se há tipos de equipamento informados
        if (tipoEquipamento.length > 0) {
            let arrayTipoEquipFormatado = JSON.stringify(tipoEquipamento);
            filtros.push({"property":"Tipo","operator":"in","value":tipoEquipamento,"and":true,"not":false});
        }
    
        // Verifica se há situações informadas
        if (situacoes.length > 0) {
            let arraySituacaoFormatada = JSON.stringify(situacoes);
            filtros.push({"property":"Situacao","operator":"in","value":situacoes,"and":true,"not":false});
        }
    
        return JSON.stringify(filtros);
    }
    

    async listarSArquivadas(codigoResponsavel, filtro) {

        let url = `api/v1/Equipamentos/${codigoResponsavel}/ListarEquipsParaSolic?page=1&start=0&limit=9999&sort=[{"property":"Descricao","direction":"ASC"}]&fields=["Id","Descricao","Situacao","Tipo","Fabricante","Modelo","NumeroFases","PotenciaKw","DataValidadeCertificacao","Ativo","DataCadastro","CodigoResponsavelTecnico","DataPrazoAnalise","DataHomologacaoCadastro","DataEnvioHomologacao","CodigoTensaoFornecimento","RespTecnico.Id","RespTecnico.Situacao","RespTecnico.Email","RespTecnico.Nome","RespTecnico.Empresa","RespTecnico.DddFone","RespTecnico.Celular","RespTecnico.CPF","RespTecnico.Crea","RespTecnico.DataValidadeCrea","RespTecnico.Ativo","RespTecnico.DataCadastro","RespTecnico.DataAprovacaoCadastro","RespTecnico.DataPrazoAnalise","RespTecnico.DataEnvioSolicitacao","TensaoFornecimento","Fabricantes"]`;

        if (filtro.trim() !== "") {
            url += `&filter=[{"property":"Modelo","operator":"containsall","value":"${filtro}","and":false},{"property":"Fabricante","operator":"containsall","value":"${filtro}","and":false},{"property":"Descricao","operator":"containsall","value":"${filtro}","and":false},{"property":"Id","operator":"equal","value":"${filtro}","and":false}]`
        }

        const response = await api({
            method: "GET",
            url
        });

        return response.data;
    };
    
    async inserir(
        descricao, 
        fabricante, 
        modelo, 
        numeroFases, 
        tipo, 
        possuiafci, 
        codigoResponsavel,
        dataCertificacao,
        potencia,
        codigoTensaoFornecimento,
        codigoFabricante
        ) 
        {
        const response = await api({
            method: "POST",
            url: "api/v1/Equipamentos",
            data: JSON.stringify({
                Descricao: descricao,
                Fabricante: fabricante,
                Modelo: modelo,
                NumeroFases: numeroFases,
                Tipo: tipo,
                PossuiAFCI: possuiafci,
                CodigoResponsavel: codigoResponsavel,
                DataValidadeCertificacao: dataCertificacao,
                PotenciaKw: potencia,
                CodigoTensaoFornecimento: codigoTensaoFornecimento,
                CodigoFabricante: codigoFabricante
            })
        });

        return response.data;
    }

    async editar (
        id,
        descricao, 
        fabricante, 
        modelo, 
        numeroFases, 
        tipo, 
        possuiafci, 
        codigoResponsavel,
        dataCertificacao,
        potencia,
        codigoTensaoFornecimento,
        codigoFabricante
    ) {
        const response = await api({
            method: "PUT",
            url: `api/v1/Equipamentos/${id}`,
            data: JSON.stringify({
                Descricao: descricao,
                Fabricante: fabricante,
                Modelo: modelo,
                NumeroFases: numeroFases,
                Tipo: tipo,
                PossuiAFCI: possuiafci,
                CodigoResponsavel: codigoResponsavel,
                DataValidadeCertificacao: dataCertificacao,
                PotenciaKw: potencia,
                CodigoTensaoFornecimento: codigoTensaoFornecimento,
                CodigoFabricante: codigoFabricante
            })
        });

        return response.data;
    }

    async AdicionarAnexoNaUseall (form) {
        const response = await api ({
            method: "POST",
            url: "/api/v1/Equipamentos/AdicionarAnexoNoEquipamento",
            headers: {
                "Content-Type": "multipart/form-data",
              },
            data: form
        });

        return response.data;
    }

    async SolicitarHomologacao (codigoEquipamento) {
        const response = await api ({
            method: "POST",
            url: `/api/v1/Equipamentos/${codigoEquipamento}/SolicitarHomologacao`
        });

        return response.data;
    }

    async SolicitarCancelamento (CodigoEquipamento, MotivoCancelamento, UsuarioCancelamento, CodigoUsuario) {
        const response = await api ({
            method: "PUT",
            url: `/api/v1/Equipamentos/${CodigoEquipamento}/CancelarEquipamentoPeloResponsavel`,
            data: JSON.stringify({
                UsuarioCancelamento,
                MotivoCancelamento,
                CodigoUsuario
            })
        });

        return response.data;
    }

    async RecuperarParaEditar (codigoEquipamento) {
        const response = await api({
            method: "GET",
            url: `api/v1/Equipamentos/${codigoEquipamento}/RecuperarParaEditar`
        });

        return response.data;
    }

    async RecuperarPrazosEquipamento (codigoEquipamento) {
        const response = await api({
            method: "GET",
            url: `api/v1/Equipamentos/${codigoEquipamento}/RecuperarPrazosEquipamento`
        });

        return response.data;
    }

    async RealizarDownloadDocumento (codigoDocumento) {
        const response = await api({
            method: "POST",
            url: "api/v1/Equipamentos/RealizarDownloadDocumento",
            data: {
                CodigoDocumento: codigoDocumento
            }
        });

        return response.data;
    }

    async RemoverDocumento(codigoDocumento) {
        const response = await api({
            method: "DELETE",
            url: `api/v1/Equipamentos/RemoverAnexoDocs/${codigoDocumento}`
        });

        return response.data;
    }
}

export default new ServEquipamentos();